import React from "react";

const SVG = ({
  style = {},
  fill = "currentColor",
  width = "100%",
  className = "",
  viewBox = "0 0 499.36 458.7"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={className || ""}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g>
		<defs>
			<clipPath id="clip-path" transform="translate(0 -.26)">
				<path className="cls-1" d="M0 0h500v459H0z" fill="none"/>
			</clipPath>
			<clipPath id="clip-path-2" transform="translate(0 -.26)">
				<path className="cls-1" d="M390.86 52.55s-1.81 168.15-19.72 225.54v.56c-9.48 32.83-39.5 64.86-82 82.56-63.15 26.33-129.69 11-148.56-34.29s17.06-103.29 80.26-129.62c52.66-22 107.65-14.73 135.44 14.78C361 139 352.47 56.23 344.66.26L47.35 73.58c-37.18 10.09-50.44 34-45.76 66.48l45.65 244.3c0 1.63.09 3.25.26 4.87s.41 3.23.73 4.83.72 3.18 1.19 4.74 1 3.09 1.65 4.59 1.33 3 2.1 4.41 1.61 2.84 2.51 4.19 1.88 2.66 2.91 3.92 2.13 2.47 3.28 3.62a48.75 48.75 0 0 0 3.61 3.28 46.37 46.37 0 0 0 3.93 2.91 45.43 45.43 0 0 0 4.18 2.52 50.6 50.6 0 0 0 13.74 5c1.6.32 3.21.57 4.83.73s3.24.25 4.87.26L412.3 459c1.63 0 3.25-.09 4.88-.25s3.23-.41 4.83-.73 3.17-.72 4.73-1.19 3.09-1 4.6-1.65 3-1.33 4.41-2.1 2.83-1.61 4.19-2.51 2.66-1.88 3.92-2.91 2.46-2.13 3.62-3.28 2.24-2.36 3.28-3.62a46.07 46.07 0 0 0 2.91-3.91c.91-1.36 1.75-2.75 2.52-4.19s1.47-2.9 2.1-4.41a46.44 46.44 0 0 0 1.65-4.59c.48-1.56.88-3.14 1.21-4.73s.56-3.21.73-4.83.25-3.25.26-4.88l37.22-385.16a43 43 0 0 0-.25-5.7c-29.76 18.96-108.25 34.19-108.25 34.19z" fill="none"/>
			</clipPath>
			<linearGradient id="linear-gradient" gradientTransform="matrix(5.04 0 0 -5.04 1747.76 2966.41)" gradientUnits="userSpaceOnUse" x1="-350.49" x2="-243.48" y1="582.78" y2="502.52">
				<stop offset="0" stopColor="#ffbd59"/>
				<stop offset=".06" stopColor="#ffbd59"/>
				<stop offset=".09" stopColor="#ffbd59"/>
				<stop offset=".1" stopColor="#ffbd59"/>
				<stop offset=".11" stopColor="#ffbb57"/>
				<stop offset=".11" stopColor="#ffb956"/>
				<stop offset=".11" stopColor="#ffb754"/>
				<stop offset=".12" stopColor="#ffb553"/>
				<stop offset=".12" stopColor="#ffb451"/>
				<stop offset=".13" stopColor="#ffb24f"/>
				<stop offset=".13" stopColor="#ffb04e"/>
				<stop offset=".13" stopColor="#ffae4c"/>
				<stop offset=".14" stopColor="#ffac4b"/>
				<stop offset=".14" stopColor="#ffaa49"/>
				<stop offset=".14" stopColor="#ffa848"/>
				<stop offset=".15" stopColor="#ffa746"/>
				<stop offset=".15" stopColor="#ffa545"/>
				<stop offset=".16" stopColor="#ffa343"/>
				<stop offset=".16" stopColor="#ffa141"/>
				<stop offset=".16" stopColor="#ff9f40"/>
				<stop offset=".17" stopColor="#ff9d3e"/>
				<stop offset=".17" stopColor="#ff9b3d"/>
				<stop offset=".18" stopColor="#ff9a3b"/>
				<stop offset=".18" stopColor="#ff983a"/>
				<stop offset=".18" stopColor="#ff9638"/>
				<stop offset=".19" stopColor="#ff9436"/>
				<stop offset=".19" stopColor="#ff9235"/>
				<stop offset=".2" stopColor="#ff9033"/>
				<stop offset=".2" stopColor="#ff8f32"/>
				<stop offset=".2" stopColor="#ff8d30"/>
				<stop offset=".21" stopColor="#ff8b2f"/>
				<stop offset=".21" stopColor="#ff892d"/>
				<stop offset=".21" stopColor="#ff872c"/>
				<stop offset=".22" stopColor="#ff852a"/>
				<stop offset=".22" stopColor="#ff8328"/>
				<stop offset=".23" stopColor="#ff8227"/>
				<stop offset=".23" stopColor="#ff8025"/>
				<stop offset=".23" stopColor="#ff7e24"/>
				<stop offset=".24" stopColor="#ff7c22"/>
				<stop offset=".24" stopColor="#ff7a21"/>
				<stop offset=".25" stopColor="#ff781f"/>
				<stop offset=".25" stopColor="#ff761d"/>
				<stop offset=".25" stopColor="#ff751c"/>
				<stop offset=".26" stopColor="#ff731a"/>
				<stop offset=".26" stopColor="#ff7119"/>
				<stop offset=".27" stopColor="#ff7018"/>
				<stop offset=".28" stopColor="#ff7018"/>
				<stop offset=".31" stopColor="#ff7018"/>
				<stop offset=".38" stopColor="#ff7018"/>
				<stop offset=".41" stopColor="#ff7018"/>
				<stop offset=".5" stopColor="#ff7018"/>
				<stop offset=".56" stopColor="#ff7018"/>
				<stop offset=".59" stopColor="#ff7018"/>
				<stop offset=".59" stopColor="#ff7119"/>
				<stop offset=".6" stopColor="#ff7219"/>
				<stop offset=".6" stopColor="#ff731a"/>
				<stop offset=".61" stopColor="#ff731a"/>
				<stop offset=".61" stopColor="#ff741a"/>
				<stop offset=".61" stopColor="#ff751b"/>
				<stop offset=".62" stopColor="#ff761b"/>
				<stop offset=".62" stopColor="#ff771c"/>
				<stop offset=".63" stopColor="#ff771c"/>
				<stop offset=".63" stopColor="#ff781d"/>
				<stop offset=".63" stopColor="#ff791d"/>
				<stop offset=".64" stopColor="#ff7a1e"/>
				<stop offset=".64" stopColor="#ff7b1e"/>
				<stop offset=".64" stopColor="#ff7c1f"/>
				<stop offset=".65" stopColor="#ff7c1f"/>
				<stop offset=".65" stopColor="#ff7d20"/>
				<stop offset=".66" stopColor="#ff7e20"/>
				<stop offset=".66" stopColor="#ff7f21"/>
				<stop offset=".66" stopColor="#ff8021"/>
				<stop offset=".67" stopColor="#ff8022"/>
				<stop offset=".67" stopColor="#ff8122"/>
				<stop offset=".68" stopColor="#ff8223"/>
				<stop offset=".68" stopColor="#ff8323"/>
				<stop offset=".68" stopColor="#ff8424"/>
				<stop offset=".69" stopColor="#ff8424"/>
				<stop offset=".69" stopColor="#ff8525"/>
				<stop offset=".7" stopColor="#ff8625"/>
				<stop offset=".7" stopColor="#ff8726"/>
				<stop offset=".7" stopColor="#ff8826"/>
				<stop offset=".71" stopColor="#ff8926"/>
				<stop offset=".71" stopColor="#ff8927"/>
				<stop offset=".71" stopColor="#ff8a27"/>
				<stop offset=".72" stopColor="#ff8b28"/>
				<stop offset=".72" stopColor="#ff8c28"/>
				<stop offset=".73" stopColor="#ff8d29"/>
				<stop offset=".73" stopColor="#ff8d29"/>
				<stop offset=".73" stopColor="#ff8e2a"/>
				<stop offset=".74" stopColor="#ff8f2a"/>
				<stop offset=".74" stopColor="#ff902b"/>
				<stop offset=".75" stopColor="#ff912b"/>
				<stop offset=".75" stopColor="#ff912c"/>
				<stop offset=".75" stopColor="#ff922c"/>
				<stop offset=".76" stopColor="#ff932d"/>
				<stop offset=".76" stopColor="#ff942d"/>
				<stop offset=".77" stopColor="#ff952e"/>
				<stop offset=".77" stopColor="#ff962e"/>
				<stop offset=".77" stopColor="#ff962f"/>
				<stop offset=".78" stopColor="#ff972f"/>
				<stop offset=".78" stopColor="#ff9830"/>
				<stop offset=".79" stopColor="#ff9930"/>
				<stop offset=".79" stopColor="#ff9a31"/>
				<stop offset=".79" stopColor="#ff9a31"/>
				<stop offset=".8" stopColor="#ff9b32"/>
				<stop offset=".8" stopColor="#ff9c32"/>
				<stop offset=".8" stopColor="#ff9d33"/>
				<stop offset=".81" stopColor="#ff9e33"/>
				<stop offset=".81" stopColor="#ff9f33"/>
				<stop offset=".82" stopColor="#ff9f34"/>
				<stop offset=".82" stopColor="#ffa034"/>
				<stop offset=".82" stopColor="#ffa135"/>
				<stop offset=".83" stopColor="#ffa235"/>
				<stop offset=".83" stopColor="#ffa336"/>
				<stop offset=".84" stopColor="#ffa336"/>
				<stop offset=".84" stopColor="#ffa437"/>
				<stop offset=".84" stopColor="#ffa537"/>
				<stop offset=".85" stopColor="#ffa638"/>
				<stop offset=".85" stopColor="#ffa738"/>
				<stop offset=".86" stopColor="#ffa739"/>
				<stop offset=".86" stopColor="#ffa839"/>
				<stop offset=".86" stopColor="#ffa93a"/>
				<stop offset=".87" stopColor="#ffaa3a"/>
				<stop offset=".87" stopColor="#ffab3b"/>
				<stop offset=".88" stopColor="#ffac3b"/>
				<stop offset=".88" stopColor="#ffac3c"/>
				<stop offset=".88" stopColor="#ffad3c"/>
				<stop offset=".89" stopColor="#ffae3d"/>
				<stop offset=".89" stopColor="#ffaf3d"/>
				<stop offset=".89" stopColor="#ffb03e"/>
				<stop offset=".9" stopColor="#ffb03e"/>
				<stop offset=".9" stopColor="#ffb13f"/>
				<stop offset=".91" stopColor="#ffb23f"/>
				<stop offset=".91" stopColor="#ffb33f"/>
				<stop offset=".91" stopColor="#ffb440"/>
				<stop offset=".92" stopColor="#ffb540"/>
				<stop offset=".92" stopColor="#ffb541"/>
				<stop offset=".93" stopColor="#ffb641"/>
				<stop offset=".93" stopColor="#ffb742"/>
				<stop offset=".93" stopColor="#ffb842"/>
				<stop offset=".94" stopColor="#ffb943"/>
				<stop offset=".94" stopColor="#ffb943"/>
				<stop offset=".95" stopColor="#ffba44"/>
				<stop offset=".95" stopColor="#fb4"/>
				<stop offset=".95" stopColor="#ffbc45"/>
				<stop offset=".96" stopColor="#ffbd45"/>
				<stop offset=".96" stopColor="#ffbd46"/>
				<stop offset=".96" stopColor="#ffbe46"/>
				<stop offset=".97" stopColor="#ffbf47"/>
				<stop offset=".97" stopColor="#ffc047"/>
				<stop offset=".98" stopColor="#ffc148"/>
				<stop offset=".98" stopColor="#ffc248"/>
				<stop offset=".98" stopColor="#ffc249"/>
				<stop offset=".99" stopColor="#ffc349"/>
				<stop offset=".99" stopColor="#ffc44a"/>
				<stop offset="1" stopColor="#ffc54a"/>
				<stop offset="1" stopColor="#ffc64b"/>
			</linearGradient>
		</defs>
		<g className="cls-2" clipPath="url(#clip-path)">
			<g className="cls-3" clipPath="url(#clip-path-2)">
				<path className="cls-4" d="M0 .26V459h499.36V.26z" fill="url(#linear-gradient)" transform="translate(0 -.26)"/>
			</g>
		</g>
	</g>
  </svg>
);

export default SVG;